"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RenderForm = _interopRequireDefault(require("../../ComponentRunner/render/RenderForm"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/config.js"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../../KESI2/KESI2BasicComponent"));

var _KesiConstants = require("../../../../KESI2/KesiConstants");

var _UrlNugget = _interopRequireDefault(require("../../../../KESI2/entities/nuggets/UrlNugget"));

var _Nugget = _interopRequireDefault(require("./Nugget.scss"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _KESI2Helper = require("../../../../KESI2/KESI2Helper");

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../helpers/DeviceInfoHelper"));

var _NavigationManagerCordova = _interopRequireDefault(require("../../../NavigationManagerCordova"));

var _RegisterInstance = _interopRequireDefault(require("../../../../KESI2/Services/RegisterInstance"));

var _HttpRequest = require("../../../../utils/HttpRequest");

var _UrlHelper = _interopRequireDefault(require("../../../../helpers/UrlHelper"));

var _MuiAlertHelper = require("../../../../helpers/MuiAlertHelper");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var DOM_PREFIX = 'eprFormContainer_';

var DrupalEPRFormNugget = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalEPRFormNugget, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalEPRFormNugget);

  function DrupalEPRFormNugget(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, DrupalEPRFormNugget);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getDomId", function () {
      return "".concat(DOM_PREFIX).concat(_this.props.id);
    });
    _this.state = _objectSpread({
      waitingForActivation: false,
      successfullySubmitted: false
    }, _this.state); // the nugget will be put there on a magic way by Reflux and props.id which is given in the constructor

    _this.active = true ^ _this.props.registerNugget(_this.props.id, _UrlNugget["default"].CLASS, _this.getDomId(), _this.props.inSwipeContainer || _this.props.inGalleryContainer || _this.props.inListContainer);
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(DrupalEPRFormNugget.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, _DataStore.DATA_STORE_PATHS.GWG_BCC_ADRESSES, _DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA]);
    return _this;
  }

  (0, _createClass2["default"])(DrupalEPRFormNugget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.registerNuggetPosition(this.props.id, _UrlNugget["default"].CLASS, this.getDomId());

      if (this.props.inListContainer) {
        this.props.setBackButtonFunc(this.props.goUpFunc);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalEPRFormNugget.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);
      var nugget = this.state.content[prevProps.id];
      var active = _DataStore["default"].pathExists("".concat(prevProps.id, ".").concat(prevProps.contentPathArray.join('!')), this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES]) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][prevProps.id][prevProps.contentPathArray.join('!')] : nugget.active;

      if (this.state.waitingForActivation && active !== this.active) {
        this.setState({
          waitingForActivation: false
        });
      }
    }
  }, {
    key: "checkUrlParamsForCampaignId",
    value: function checkUrlParamsForCampaignId() {
      // check if start url is given
      var urlParams = _UrlHelper["default"].getUrlParams();

      console.log('checkUrlParamsForCampaignId', urlParams);

      if ('campaignId' in urlParams) {
        return urlParams['campaignId'];
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      /**
       * @type {EPRFormNugget}
       */
      var nugget = this.state.content[this.props.id];
      var active = _DataStore["default"].pathExists("".concat(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, ".").concat(this.props.id, ".").concat(this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER))) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] || nugget.active : nugget.active;
      var innerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].innerHidden) : '';
      var outerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].outerHidden) : '';

      var isAuthor = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_SHOW_UNPUBLISHED_CONTENT);

      var handleSubmit = /*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(record) {
          var recordToSend, token, authToUse, campaignIdToSend, response, form, title, message, _oldObject, _oldObject2, _oldObject3, oldObject, newObject, newEntry, newPreconditionData;

          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(nugget.postPath && nugget.postScopes)) {
                    _context.next = 25;
                    break;
                  }

                  _context.prev = 1;
                  recordToSend = {};
                  (0, _keys["default"])(record).forEach(function (path) {
                    var data = record[path];

                    if (data && data.value) {
                      recordToSend[path] = data.value;
                    } else {
                      recordToSend[path] = data;
                    }
                  });
                  _context.next = 6;
                  return _RegisterInstance["default"].getAccessToken(nugget.postScopes);

                case 6:
                  token = _context.sent;
                  authToUse = "Bearer ".concat(token);
                  console.log('sending json record to post path', recordToSend);
                  campaignIdToSend = _this2.checkUrlParamsForCampaignId();

                  if (campaignIdToSend) {
                    recordToSend.campaignId = campaignIdToSend;
                  }

                  _context.next = 13;
                  return (0, _HttpRequest.httpPostJsonEncoded)(nugget.postPath, recordToSend, null, 30000, null, authToUse);

                case 13:
                  response = _context.sent;
                  console.log('response sending json record to post path', response);

                  if (response.status === 200 || response.status === 201) {
                    _this2.setState({
                      successfullySubmitted: true
                    });

                    form = JSON.parse(nugget.json);
                    console.log('form', form);

                    if (form && form.successDialog) {
                      title = form.successDialog.title || 'Titel in Drupal fehlt';
                      message = form.successDialog.message || 'Message in Drupal fehlt';
                      (0, _MuiAlertHelper.showAlertWithOptions)({
                        title: title,
                        message: message
                      });
                    }

                    if (_config["default"].goHomeAfterSendingFormNugget) {
                      if (_this2.props.goHomeFn) {
                        _this2.props.goHomeFn();
                      } else {
                        _NavigationManagerCordova["default"].goHome();
                      }
                    }
                  } else if (!response.success && response.errors) {
                    (0, _MuiAlertHelper.showAlertWithOptions)({
                      title: 'Fehler beim Absenden',
                      html: "Der Interessent konnte nicht gespeichert werden.<br /><br />Fehler: ".concat(response.errors[0])
                    });
                  }

                  _context.next = 23;
                  break;

                case 18:
                  _context.prev = 18;
                  _context.t0 = _context["catch"](1);
                  console.log('there was an error sending the data', _context.t0);
                  (0, _MuiAlertHelper.showAlertWithOptions)({
                    title: 'Fehler beim Absenden',
                    html: "Der Interessent konnte nicht gespeichert werden.<br /><br />Fehler: ".concat(_context.t0.message.replace(_HttpRequest.HTTP_ERROR_PREFIX, ''))
                  });

                  if (_config["default"].goHomeAfterSendingFormNugget) {
                    if (_this2.props.goHomeFn) {
                      _this2.props.goHomeFn();
                    } else {
                      _NavigationManagerCordova["default"].goHome();
                    }
                  }

                case 23:
                  _context.next = 42;
                  break;

                case 25:
                  if (!(nugget.dataStorePath && nugget.logInArray)) {
                    _context.next = 39;
                    break;
                  }

                  oldObject = _DataStore["default"].getElementByPathImmediately(nugget.dataStorePath);

                  if (!((_oldObject = oldObject) === null || _oldObject === void 0 ? void 0 : _oldObject.Values) || !(0, _isArray["default"])((_oldObject2 = oldObject) === null || _oldObject2 === void 0 ? void 0 : _oldObject2.Values)) {
                    oldObject = {
                      Values: []
                    };
                  }

                  newObject = JSON.parse((0, _stringify["default"])(oldObject));
                  newEntry = {
                    date: (0, _now["default"])(),
                    value: record
                  };
                  newObject.Values.push(newEntry);
                  newPreconditionData = [];

                  if (((_oldObject3 = oldObject) === null || _oldObject3 === void 0 ? void 0 : _oldObject3.preconditionData) && (0, _isArray["default"])(oldObject.preconditionData)) {
                    newPreconditionData.push.apply(newPreconditionData, (0, _toConsumableArray2["default"])(oldObject.preconditionData));
                  }

                  if ((record === null || record === void 0 ? void 0 : record.preconditionData) && (0, _isArray["default"])(record.preconditionData)) {
                    newPreconditionData.push.apply(newPreconditionData, (0, _toConsumableArray2["default"])(record.preconditionData));
                  }

                  newObject.preconditionData = newPreconditionData;
                  _context.next = 37;
                  return _DataStore["default"].setSingleData(nugget.dataStorePath, newObject);

                case 37:
                  _context.next = 42;
                  break;

                case 39:
                  if (!nugget.dataStorePath) {
                    _context.next = 42;
                    break;
                  }

                  _context.next = 42;
                  return _DataStore["default"].setSingleData(nugget.dataStorePath, record);

                case 42:
                  if (nugget.isAutoSave) {} else if (_this2.props.goHomeFn && _config["default"].goHomeAfterSendingFormNugget) {
                    _this2.props.goHomeFn();
                  }

                case 43:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[1, 18]]);
        }));

        return function handleSubmit(_x) {
          return _ref.apply(this, arguments);
        };
      }();

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "eprFormContainer ".concat(nugget.theme, " ").concat(_DeviceInfoHelper["default"].isBrowser() ? '' : 'mobile', " ").concat(this.getDomId(), " ").concat(_Nugget["default"].outerContainer, " ").concat(outerClassNames),
        id: this.getDomId(),
        style: this.props.inSwipeContainer || this.props.inListContainer || this.props.inGalleryContainer ? {
          width: '100%',
          padding: 0,
          margin: 0
        } : {}
      }, _config["default"].showNuggetIcons && this.props.renderIcon ? this.props.renderIcon(nugget) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_Nugget["default"].container, " ").concat(innerClassNames)
      }, isAuthor && !nugget.isPublished && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          padding: '10px',
          color: 'red'
        }
      }, "Content unver\xF6ffentlicht"), nugget.show_title ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "eprTitle ".concat(this.props.inGalleryContainer ? 'titleSmall' : 'title')
      }, nugget.title) : null, /*#__PURE__*/_react["default"].createElement(_RenderForm["default"], {
        onSubmit: function onSubmit(record) {
          return handleSubmit(record);
        },
        form: JSON.parse(nugget.json),
        isAutoSave: nugget.isAutoSave,
        isLogInArray: nugget.logInArray,
        nuggetPath: nugget.dataStorePath
      })));
    }
  }]);
  return DrupalEPRFormNugget;
}(_KESI2BasicComponent["default"]);

exports["default"] = DrupalEPRFormNugget;
DrupalEPRFormNugget.propTypes = {
  id: _propTypes["default"].string.isRequired,
  path: _propTypes["default"].string,
  registerNugget: _propTypes["default"].func.isRequired,
  markAsRead: _propTypes["default"].func.isRequired,
  contentPathArray: _propTypes["default"].array.isRequired,
  inSwipeContainer: _propTypes["default"].bool.isRequired,
  inListContainer: _propTypes["default"].bool.isRequired,
  inGalleryContainer: _propTypes["default"].bool.isRequired,
  goUpFunc: _propTypes["default"].func,
  renderIcon: _propTypes["default"].func.isRequired,
  onSubmitFn: _propTypes["default"].func
};
DrupalEPRFormNugget.defaultProps = {
  id: null
};